<div class="endpoint-section">
  <div class="mode-direction">
    <div class="label-container mode" *ngIf="showTestMode">
      <div class="label">Test mode</div>
      <mat-select
        [disabled]="editMode"
        class="mode_select"
        [(ngModel)]="testMode"
        (ngModelChange)="onTestModeChange($event)"
      >
        <mat-option *ngFor="let mode of testInfo" [value]="mode.testMode">{{
          mode.testModeName
        }}</mat-option>
      </mat-select>
    </div>
    <div class="endpoint-section">
      <div class="label-container mode" *ngIf="showDirections">
        <div class="label">Directions</div>
        <mat-select
          [disabled]="isDirectionEditable()"
          class="mode_select direction"
          [(ngModel)]="direction"
          (ngModelChange)="onDirectionChange($event)"
        >
          <mat-option *ngFor="let direction of availableDirections" [value]="direction.value">{{
            direction.name
          }}</mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="mode-direction">
    <div class="label-container agent">
      <label class="label">Source</label>
      <nrwl-endpoint-selection-panel
        [endpointValue]="originatorValue"
        [editMode]="editMode"
        (openEndpoint)="viewOriginator()"
        [endpointConfiguration]="originatorConfiguration"
      >
      </nrwl-endpoint-selection-panel>
    </div>
    <div
      class="direction-icons"
      *ngIf="showDirectionIcons"
      [ngClass]="{ 'extern-align': isExternUrlEnabled }"
    >
      <div class="test-icon" *ngIf="direction !== testModeOptions.DOWNLOAD">
        <i class="mdi mdi-arrow-right-bold icons-24 upload-symbol"></i>
        <span>Upload</span>
        <i class="mdi mdi-arrow-right-bold icons-24 upload-symbol"></i>
      </div>
      <div class="test-icon" *ngIf="direction !== testModeOptions.UPLOAD">
        <i class="mdi mdi-arrow-left-bold icons-24 dwn-symbol"></i>
        <span>Download</span>
        <i class="mdi mdi-arrow-left-bold icons-24 dwn-symbol"></i>
      </div>
    </div>
    <div class="label-container agent" *ngIf="showDestination">
      <label class="label">Destination</label>
      <nrwl-endpoint-selection-panel
        [endpointValue]="destinationValue"
        [editMode]="editMode"
        [loopbackType]="loopbackType"
        (openEndpoint)="viewDestination()"
        [endpointConfiguration]="destinationConfiguration"
      ></nrwl-endpoint-selection-panel>
    </div>
  </div>
</div>
